import {defineComponent, onBeforeMount, onMounted, ref} from 'vue';
import {every, isEmpty} from 'lodash-es';
import * as yup from 'yup';
import {useMounted} from '@vueuse/core';
import {IDrawZoneMapGeometry} from '@/app/shared/components/kl-draw-zone-map/kl-draw-zone-map';
import {ICreateOrUpdateMapRequestInput} from '@/api/klip-api.proxy';
import {useIsMobile} from '@/app/shared/composables/useIsMobile';

export interface IKlMriCreateStep3Result {
    zones: IDrawZoneMapGeometry[];
    totalPrice: number;
    isValid: boolean;
}

export default defineComponent({
    name: 'KlMriCreateStep3',
    emits: ['submit'],
    props: {
        showMap: {type: Boolean, required: false, default: false},
        prefill: {type: Object as () => ICreateOrUpdateMapRequestInput, required: false, default: null},

        reference: {type: String, required: false, default: null},
        includeImkl: {type: Boolean, required: false, default: false},

        isSending: {type: Boolean, required: false, default: false},
        isError: {type: Boolean, required: false, default: false},
        errorMessages: {type: Array<string>, required: false, default: null},

        saveButtonLabel: {type: String, required: false, default: null},

    },
    setup(props, { emit }) {

        const isMounted = useMounted();

        const mapRules = yup.object()
            .required()
            .kl_isPolygon()
            .kl_notSelfIntersectingPolygon()
            .kl_zoneSmallerThan(100000, '100.000')
            .kl_zoneShorterThan(100000, '100.000')
            .kl_zonePartiallyInFlanders()
            .kl_zoneInBufferedFlanders()
            .kl_zoneGeometrySmallerThanXBytes(64000);

        const zones = ref<IDrawZoneMapGeometry[]>(null);
        const totalPrice = ref<number>(0);
        const isValid = ref<boolean>(false);

        const usePhoneMode = ref<boolean>(false);

        const onZonesChanged = (newZones: IDrawZoneMapGeometry[]) => {
            zones.value = newZones;
            _validateStep3();
        }

        const _validateStep3 = () => {
            isValid.value = !isEmpty(zones.value) && every(zones.value, (cz: IDrawZoneMapGeometry) => !!cz.isValid);
        }

        const onZonePrice = (price: number) => {
            totalPrice.value = price;
        }

        const onSubmit = () => {
            emit('submit', <IKlMriCreateStep3Result>{
                zones: zones.value,
                totalPrice: totalPrice.value,
                isValid: isValid.value,
            });
        }

        onBeforeMount(() => {
            usePhoneMode.value = useIsMobile().value;
        });

        onMounted(() => {
            if (props.prefill?.mapRequestZone) {
                zones.value = [props.prefill?.mapRequestZone];
            }
        })

        return {
            isMounted,

            mapRules,
            zones,
            totalPrice,
            isValid,

            onZonesChanged,
            onZonePrice,

            onSubmit,

            usePhoneMode,
        }
    }
});
